export default __webpack_public_path__ + "c2096f3a821bdf3ddebd7e8bf64df89e.jpg";